import { httpClient } from '../core/http';
import { HealthResponse } from '../types';

export class HealthService {
  async checkHealth(): Promise<HealthResponse> {
    const response = await httpClient.get<HealthResponse>('/health/');
    return response.data;
  }

  async isHealthy(): Promise<boolean> {
    try {
      const health = await this.checkHealth();
      return health.status === 'healthy' || health.status === 'ok';
    } catch (error) {
      return false;
    }
  }
}
